<template>
  <div class="app flex-row align-items-center animated fadeIn">
    <div class="container">
      <img class="d-block mx-auto mb-3" src="/img/logo-full.png" />
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-alert :show="errors.any()" variant="danger" class="px-4">
            <ul class="m-0 px-1">
              <li v-for="err in errors.all()" :key="err">{{err}}</li>
            </ul>
          </b-alert>
          <b-card class="p-3">
            <b-form-group v-if="$config.auth.registerByUsername">
              <b-input-group :prepend="$t('users.Username')">
                <b-form-input
                v-model="model.user.userName"
                dir="ltr"
                :name="$t('users.Username')"
                v-validate="'required'"/>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group :prepend="$t('shared.Email')">
                <b-form-input
                  v-model="model.user.email"
                  dir="ltr"
                  :name="$t('shared.Email')"
                  v-validate="$config.auth.registerByEmail ? 'required|email' : null">
                </b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group :prepend="$t('users.Password')">
                <b-form-input
                  v-model="model.password"
                  type="password"
                  dir="ltr"
                  :name="$t('users.Password')"
                  v-validate="'required|min:6|confirmed:pwdcfrm'"/>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group :prepend="$t('users.PasswordConfirm')">
                <b-form-input
                  v-model="passwordConfirm"
                  type="password"
                  dir="ltr"
                  ref="pwdcfrm"/>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group :prepend="$t('users.FirstName')">
                <b-form-input
                  v-model="model.user.firstName"
                  dir="auto">
                </b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group :prepend="$t('users.LastName')">
                <b-form-input
                  v-model="model.user.lastName"
                  dir="auto">
                </b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group>
                <b-input-group-prepend is-text>
                  {{$t('shared.Mobile')}}
                </b-input-group-prepend>
                <b-form-input
                v-model="model.user.phoneNumber"
                dir="ltr"
                :name="$t('shared.Mobile')"
                placeholder= "912xxxxxxx"
                v-validate="($config.auth.registerByMobile) ? 'required|digits:10' : 'digits:10'"/>
                <b-input-group-append is-text dir="ltr">
                  {{$config.country.phoneCode}}
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group :prepend="$t('users.Gender')">
                <b-form-select v-model="model.profile.gender" :options="genders" />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <date-picker
              :label="$t('users.Birthdate')"
              :name="$t('users.Birthdate')"
              v-model="model.profile.birthDate" />
            </b-form-group>
            <b-btn variant="primary" block :disabled="progressing" @click="submit()">{{$t('account.Register')}}</b-btn>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/types'
import { DatePicker } from '@/components/shared'

export default {
  name: 'register',
  components: {
    DatePicker
  },
  data () {
    return {
      progressing: false,
      model: {
        user: {
          userName: null,
          firstName: null,
          lastName: null,
          email: null,
          phoneCode: this.$config.country.phoneCode,
          phoneNumber: null
        },
        profile: {
          gender: null,
          birthDate: null
        },
        password: null
      },
      passwordConfirm: null,
      genders: [
        { value: null, text: this.$t('shared.Choose') },
        { value: 0, text: this.$t('users.Female') },
        { value: 1, text: this.$t('users.Male') },
      ]
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.progressing = true
          this.model.user.userName =
          this.$config.auth.registerByEmail ? this.model.user.email :
          this.$config.auth.registerByMobile ? this.model.user.phoneNumber : this.model.user.userName
          this.$api.account.register(this.model, true)
          .then(() => {
            this.$showSuccess(this.$t('account.RegisterSuccessful'))
            this.$router.push('/')
            this.progressing = false
          })
          .catch(err => {
            this.error = this.$getLocaleErrorMessage(err, 'account')
            this.progressing = false
          })
        }
      })
    }
  }
}
</script>
